// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isIntegrationsVoucherGroupsResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      name: string,
      code_snippet: string,
      remaining: number,
      total: number,
      tag_names: arrayOf(string),
    })
  ),
});
